export const allowedPaymentMethods = ['sepa_debit', 'card'] as const

export type AllowedPaymentMethod = typeof allowedPaymentMethods

export const paymentMethodsDisplayInfo = {
  sepa_debit: {
    label: 'Addebito SEPA'
  },
  card: {
    label: 'Carta'
  }
}
